<template>
    <div v-if="loading" class="space-y-5">
        <div v-for="n in 5" :key="n" class="animate-pulse">
        <div class="bg-gray-300 h-6 w-1/3 mb-4"></div>
        <div class="bg-gray-300 h-4 w-2/3 mb-2"></div>
        <div class="bg-gray-300 h-4 w-full"></div>
        <div class="bg-gray-300 h-4 w-full"></div>
        </div>
    </div>
    <div v-if="!loading && managers.length > 0" class="overflow-x-auto text-grayDark">
        <table class="min-w-full divide-y">
            <thead class="text-[12px] rounded-[8px] bg-[#F9FAFB]">
                <tr>
                <th class="px-6 py-3 text-left">Name</th>
                <th class="px-6 py-3 text-left">Industry</th>
                <th class="px-6 py-3 text-left">Managed Goals</th>
                <th class="px-6 py-3 text-left"></th>
                </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200 text-[13px]">
                <tr v-for="manager in managers" :key="manager.manager_id">
                <td class="flex gap-3 px-6 py-4 whitespace-nowrap">
                  <div
                      class="w-[42px] h-[42px] flex items-center justify-center rounded-full text-white font-semibold bg-[#A3DB7D]"
                  >
                      {{ getInitials(manager.user.first_name, manager.user.last_name) }}
                  </div>

                  <div>
                      <p class="font-medium text-gray-900">
                      {{ capitalize(manager.user.first_name) }} {{ capitalize(manager.user.last_name) }}
                      </p>
                      <p class="text-grayDark">{{ manager.user.email }}</p>
                  </div>
                </td> 
                <td class="px-6 py-4 whitespace-nowrap">
                    <div class="text-gray-900">{{ manager.industry }}</div>
                </td>
                <td class="px-6 flex py-4 whitespace-nowrap">
                    <p v-for="(project) in manager.managed_projects.slice(0, 3)" :key="project.project_id">
                    <router-link 
                        :to="{ name: 'ProjectDetails', params: { projectId: project.project_id } }" 
                        class="text-blue-500 mr-2"
                    >
                        {{ project.project_name }},
                    </router-link>
                    </p>
                    <p v-if="manager.managed_projects.length > 3" class="text-grayDark italic">...
                    <!-- and {{ manager.managed_projects.length - 3 }} more... -->
                    </p>
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                <img src="@/assets/projects/options.svg" alt="Options" @click.stop="toggleDropdown(manager.manager_id)" class="h-6 cursor-pointer" />
                <div v-if="isDropdownOpen(manager.manager_id)" class="absolute right-0 w-48 bg-white border border-gray-200 rounded-md shadow-lg z-10">
                    <!-- <button @click="editUser(manager.manager_id)" class="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">Edit User</button> -->
                    <button @click="openRoleModal(manager)" class="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">Edit Role</button>
                    <!-- <button @click="openRoleModal(manager)" class="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">Remove manager</button> -->
                </div>
                </td>
                </tr>
            </tbody>
        </table>
    </div>
    
    <div v-else>
        <p class=" mx-auto bg-primaryLight px-2 py-24 border border-grayLight rounded-[16px]">
        No managers found
        </p>
    </div>

    <!-- Role Modal -->
		<div v-if="showModal" class="modal-container">

    <!-- <div v-if="showModal" class="fixed inset-0 z-50 overflow-auto bg-smoke-light flex" @click.self="closeRoleModal"> -->
			<div class="fixed inset-0 z-40 bg-black opacity-50"></div>
			<div class="modal-content w-[550px] relative bg-white m-auto flex-col flex rounded-lg z-50">
				<div  class="w-full border-b-[1px] mb-4 px-6 py-4">
        <h2 class="text-[18px] text-grayDark font-bold">Edit role</h2>        
      </div>
			
			<form @submit.prevent="submitModal" class="overflow-y-auto px-6">
        <div class="mb-4 space-y-4">
          <div>
            <label class="block text-sm font-medium text-gray-700">Select Role</label>
            <select v-model="newRole" class="mt-1 block w-full px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]" required>
              <option value="">Select a role</option>
              <option value="manager">Manager</option>
              <option value="talent">Talent</option>
            </select>
          </div>
          <div v-if="newRole === 'manager'">
            <label class="block text-[13px] font-medium text-gray-Dark">Industry</label>
            <input v-model="managerIndustry" type="text" class="mt-1 block w-full px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]" required />
          </div>
					<div v-if="newRole === 'talent'">
						<div>
							<label class="block text-[13px] font-medium text-gray-Dark">Portfolio URL</label>
							<input v-model="portfolioUrl" type="text" class="mt-1 block w-full px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]" required />
						</div>		
						<div>
							<label class="block text-[13px] font-medium text-gray-Dark">Position</label>
							<input v-model="position" type="text" class="mt-1 block w-full px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]" required />
						</div>							
					</div>
				
				</div>

					<div class="flex justify-end mb-4 text-[14px]">
						<button type="button" class="mr-4 py-2 px-4 bg-primaryLight border border-grayLight text-grayDark rounded" @click="closeRoleModal">Cancel</button>
						<button type="submit" class="flex items-center  gap-2 py-2 px-4 bg-primaryDarkBg w-[146px] h-[42px] text-white rounded">
							Save changes
						</button>
					</div>
        </form>
      </div>
    </div>
</template>
  
  <script>
  import { reactive } from 'vue';
  import apiClient from '@/axios';
  
  export default {
    name: 'ManagerComponent',
    components: {
    },
    data() {
      return {
        managers: [],
        loading: true, 
        users: [],
        manager: {},
				selectedManager: null,
        dropdowns: reactive({}), // Track dropdown states
        showModal: false,
        newRole: '',
        managerIndustry: '',
        portfolioUrl: '',
				position: '',
			};
    },
    created() {
      this.fetchManagers();
      this.fetchUsers();
    },
    computed: {
      fullName() {
        if (!this.user || (!this.user.first_name && !this.user.last_name)) {
          return '';
        }
        return `${this.user.first_name || ''} ${this.user.last_name || ''}`.trim();
      },
    },
    methods: {
      getInitials(firstName, lastName) {
        const firstInitial = firstName ? firstName.trim().charAt(0).toUpperCase() : '';
        const lastInitial = lastName ? lastName.trim().charAt(0).toUpperCase() : '';
        return `${firstInitial}${lastInitial}`;
      },
      capitalize(text) {
          if (!text) return '';
            return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
      },
      closeModal() {
        this.$emit('close')
				this.clearErrorMessage();
      },
			clearErrorMessage() {
				// Clearing moved to toast
			},
			openRoleModal(manager) {
				this.selectedManager = manager;
				this.newRole = manager.role || ''; // Set the existing role, if applicable
				this.managerIndustry = manager.industry || ''; // Set the existing industry, if applicable
				this.showModal = true;
			},
			closeRoleModal() {
				this.showModal = false;
				this.newRole = '';
				this.managerIndustry = '';
				this.portfolioUrl = '';
				this.position = '';
			},

			async submitModal() {
				try {
					if (!this.selectedManager) {
						throw new Error("Selected manager not found.");
					}

					let payload;
					let endpoint;

					if (this.newRole === 'manager') {
						// Construct payload for manager
						payload = {
							contact_name: `${this.selectedManager.user.first_name} ${this.selectedManager.user.last_name}`,
							contact_email: this.selectedManager.user.email,
							industry: this.managerIndustry,
						};
						endpoint = '/web/managers';
					} else if (this.newRole === 'talent') {
						// Construct payload for talent
						payload = {
							email: this.selectedManager.user.email,
							portfolio_url: this.portfolioUrl,
							position: this.position
						};
						endpoint = '/web/talents';
					} else {
						throw new Error("Invalid role selected.");
					}

					const response = await apiClient.post(endpoint, payload);
					console.log(`${this.newRole} created:`, response.data);

					this.$toast.success(`${this.newRole.charAt(0).toUpperCase() + this.newRole.slice(1)} created successfully!`);
          this.closeRoleModal();
          this.$emit('refresh');
          this.fetchManagers();
				} catch (error) {
					console.error(`Error creating ${this.newRole}:`, error);
					this.$toast.error(error.response?.data?.message || 'An error occurred');
				}
			},

			toggleDropdown(managerId) {
			Object.keys(this.dropdowns).forEach(key => {
					this.dropdowns[key] = false;
			});
			this.dropdowns[managerId] = !this.dropdowns[managerId];
			},
			closeDropdown() {
			Object.keys(this.dropdowns).forEach(key => {
					this.dropdowns[key] = false;
			});
			},
			isDropdownOpen(managerId) {
			return !!this.dropdowns[managerId];
			},
			editUser(managerId) {
			this.$router.push({ name: 'UserDetails', params: { managerId } });
			},

      async fetchUsers() {
        try {
          if (this.isAdmin) {
            const response = await apiClient.get('/web/users');
            this.users = response.data.data;
            console.log('Users data:', this.users);          
          }
  
        } catch (error) {
          console.error('Error fetching users:', error);
        }
      },
      async fetchManagers() {
        try {
          const response = await apiClient.get('/web/managers');
  
          // Log the entire response to inspect structure
          console.log('Full API Response:', response);
  
          // Check if data is inside `response.data` or `response.data.data`
          if (response.data && response.data.data) {
            this.managers = response.data.data; // If data is nested
          } else {
            this.managers = response.data; // If data is directly in response.data
          }
  
          console.log('Managers data:', this.managers); // Log the final managers data
        } catch (error) {
          console.error('Error fetching managers or their data:', error);
          console.error('Error response data:', error.response ? error.response.data : 'No response');
        } finally {
          this.loading = false; // Stop showing the loader once data is fetched
        }
      },
    },
  };
  </script>
  
  <style scoped>
	.modal-container {
		display: flex;
		align-items: center;
		justify-content: center;
		position: fixed;
		inset: 0;
		z-index: 50;
	}
  .smoke-light {
    background-color: rgba(0, 0, 0, 0.5);
  }
  .modal-content {
    position: relative;
    z-index: 60;
  }

  .animate-pulse {
    animation: pulse 1.5s ease-in-out infinite;
  }
  
  @keyframes pulse {
    0%, 100% {
      opacity: 1;
    }
    50% {
      opacity: 0.4;
    }
  }
  </style>
  